import React from "react";

function Header() {
    return (
        <h2>TodoMachine</h2>
    )
}

export { Header }